import React from 'react';
import { ApolloProvider } from 'react-apollo';
import client from './src/apollo/Client';
import "prismjs/themes/prism-okaidia.css";

export const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider client={client}>
      {element}
    </ApolloProvider>
  )
}
